<template>
  <div class="mb-4">
    <h4 class="text-center" v-if="category">{{ categoryName }}</h4>

    <div class="form-group row">
      <div class="col-sm-8">
        <strong>Enabled</strong>
      </div>
      <div class="col-sm-4">
        <strong>Timeline, hours</strong>
      </div>
    </div>

    <div class="form-group row" v-for="(type, id) in modelValue">
      <div class="col-sm-1">
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   :name="'timeline_type[' + (category ? category + '][' + id : id) + '][status]'"
                   :value="true"
                   v-model="type.status">
          </label>
        </div>
      </div>
      <label for="" class="col-sm-7 col-form-label">{{ type.name }}</label>
      <div class="col-sm-4">
        <input class="form-control form-control-sm"
               :name="'timeline_type[' + (category ? category + '][' + id : id) + '][interval]'"
               :value="type.interval"
               v-model="type.interval">
      </div>
    </div>
  </div>
</template>

<script>

export default {

  emits: ['update:modelValue'],

  props: {

    // Daily or Cat category
    category: {
      type: String,
    },

    // Timelines array, should contain 'name', 'status', 'interval'
    modelValue: {
      type: Object,
      required: true,
    },
  },

  watch: {
    modelValue: {
      deep: true,
      handler(value) {
        this.$emit('update:modelValue', value);
      }
    },
  },

  computed: {
    categoryName() {
      return this.category.charAt(0).toUpperCase() + this.category.slice(1);
    }
  },

}
</script>
